<div class="pdf-row-preview"
     [style.fontSize.px]="fontSize"
     [style.fontWeight]="fontWeight"
     [style.fontStyle]="fontStyle"
     [style.color]="color"
     [style.textAlign]="textAlign"
     [style.justifyContent]="textAlign === 'center' ? 'center' : (textAlign === 'right' ? 'flex-end' : 'flex-start')">
  <span *ngFor="let element of resolvedElements" class="row-element">{{ element.displayValue }}</span>
  <span *ngIf="resolvedElements.length === 0" class="empty-placeholder">[Configure row elements]</span>
</div>
